module.exports = __webpack_public_path__ + "static/chula-480ea2cef903d4059b43e2f51af9dd7d.svg";